import { Component, Vue, Watch } from 'vue-property-decorator';
import { getModule} from 'vuex-module-decorators';
import axios, {AxiosPromise}  from 'axios';

import User from "@/module/store/user";
import {CONFIG_ENV} from '@/config';
import {LocalStorage} from "quasar";
import  {getProfileImgAsString}  from '@/module/utils';

interface I_AjaxResponse_SaveMyProfile{
    status:number,
    statusText:string,
    data: {
        status:string,
        email_must_to_cheked:string,
        message:string,
    }
}

interface I_MyProfile {
    firstName:string,
    lastName:string,
    email:string,
    newPassword:string,
    newPasswordRetyped:string,
    motto:string
}


@Component({components:{}})
export default class MyProfile extends Vue {
    isAjaxLoadingLists:boolean=false;
    myBoolFalse:boolean=false;
    showNecessaryInfoForPasswordChange:boolean=false;
    showDialogForChangeImgProfile:boolean=false;
    myProfile:I_MyProfile={
        firstName:'',
        lastName:'',
        email:'',
        newPassword:'',
        newPasswordRetyped:'',
        motto:''
    }
    userStore=getModule(User);
    getUrlForUploadProfileImage:string=CONFIG_ENV.URL_USER.uploadImageMyProfile+'/'+this.userStore.user.userid;
    getUrlForDownloadProfileImage:string=CONFIG_ENV.URL_USER.getMyImageProfile+'/'+this.userStore.user.userid+'?t=' + Math.random();

    $refs:any;



    async saveMyProfile(myProfile:I_MyProfile){
        const vueInst=this;
        const userid=LocalStorage.getItem('userid');
        let res = await <Promise<I_AjaxResponse_SaveMyProfile>> axios.post(`${CONFIG_ENV.URL_USER.saveMyProfile}/${userid}`,myProfile);
        return res;
    }

    reloadProfileImage():void{
        const vueInst=this;
        vueInst.getUrlForDownloadProfileImage=CONFIG_ENV.URL_USER.getMyImageProfile+'/'+vueInst.userStore.user.userid+'?t=' + Math.random();

        getProfileImgAsString(vueInst.userStore.user.userid).then((response:any)=>{
                LocalStorage.set('MyImgProfileString64', response.data);
                vueInst.userStore.set_myimgprofilestring64r(response.data);
            });
    }

    imgForProfileWasUploaded(){
        const vueInst=this;
        vueInst.showDialogForChangeImgProfile=false;
        vueInst.reloadProfileImage();
        vueInst.$q.notify({
            color: 'teal',
            textColor: 'white',
            position:'bottom-right',
            timeout: 1500,
            icon: 'fas fa-exclamation-triangle',
            message: 'Imaginea de profil a fost schimbata'
        });
    }

    blurInputNewPassword() {
        var vueInst=this;
        if (vueInst.myProfile.newPassword.length == 0) {
            vueInst.showNecessaryInfoForPasswordChange = false;
        }
    }

    checkPasswordIfRetypedEqual(val:string){
        const vueInst=this;
        let error_message='';
        if (vueInst.myProfile.newPassword.length > 0) {
            if(vueInst.myProfile.newPasswordRetyped.length==0){
                error_message='Reintroduceti parola';
            }
            else{
                if(vueInst.myProfile.newPassword!=vueInst.myProfile.newPasswordRetyped){
                    error_message='Parolele nu coincid, corectati!';
                }
                if(vueInst.myProfile.newPassword==vueInst.myProfile.newPasswordRetyped && (vueInst.myProfile.newPassword.length <4 || vueInst.myProfile.newPassword.length>20)){
                    error_message='Parola trebuie sa aiba intre 4 si 20 de carcatere';
                }
            }
            return (error_message.length==0? true:error_message);
        }



    console.log('checkPasswordIfRetypedEqual with val=%o',val);

    }

    onSubmit(){
        const vueInst=this;
        vueInst.saveMyProfile(vueInst.myProfile).then(response=>{
            if(response.data.status=='success'){

                if(response.data.email_must_to_cheked=='yes'){
                    vueInst.logout();
                    vueInst.$q.dialog({
                        title: 'Alert<em>!</em>',
                        message: '<em>I can</em> <span class="text-red">use</span> <strong>HTML</strong>',
                    });
                }
            else{
                    this.$router.push({ name: 'my_home_page' });
                }
            }else{
                vueInst.$q.notify({
                    color: 'red',
                    textColor: 'white',
                    position:'top-right',
                    timeout: 3000,
                    icon: 'fas fa-exclamation-triangle',
                    message: response.data.message
                });
            }
        });
    }

    logout(){
        LocalStorage.set('isAuthenticated', 'no');
        LocalStorage.set('token_for_permanent_session', 'x');
        LocalStorage.set('userid', '0');
        this.$router.push({ name: 'home' });
        this.userStore.set_user({
            userid:'0',
            email:'',
            lastName:'',
            firstName:'',
            isEmailChecked:true,
            isAuthenticated:false,
            csrf_token:'x'});
    }
    constructor(){
        super();
        this.myProfile.firstName=this.userStore.user.firstName;
        this.myProfile.lastName=this.userStore.user.lastName;
        this.myProfile.email=this.userStore.user.email;
    }

    get MyImgProfileString64():string{
        return this.userStore.MyImgProfileString64;
    }

    activated(){
        this.myProfile.firstName=this.userStore.user.firstName;
        this.myProfile.lastName=this.userStore.user.lastName;
        this.myProfile.email=this.userStore.user.email;
    }
}
